import { PythonRunner } from "../../pyodide"


export const getInputVariables = (code: string, pyodideInstance: PythonRunner) => {

    const pythonCode = `
import ast

def extract_function_structure(function_code):
    tree = ast.parse(function_code)
    inputs_structure = {}
    outputs_structure = {}
    
    for node in ast.walk(tree):
        if isinstance(node, ast.Call) and isinstance(node.func, ast.Attribute):
            if node.func.attr == 'get':
                key = node.args[0].s
                if 'request' in ast.dump(node.func.value):
                    inputs_structure[key] = 'unknown'  # Type inference would be more complex
        elif isinstance(node, ast.Return):
            if isinstance(node.value, ast.Dict):
                outputs_structure = extract_dict_structure(node.value)

    return inputs_structure, outputs_structure

def extract_dict_structure(dict_node):
    structure = {}
    for key, value in zip(dict_node.keys, dict_node.values):
        if isinstance(value, ast.Dict):
            structure[key.s] = extract_dict_structure(value)
        else:
            structure[key.s] = 'unknown'  # Simplification for this example
    return structure

# Example usage:
function_code = """
${code}
"""

inputs, outputs = extract_function_structure(function_code)
print("Inputs Structure:", inputs)
print("Outputs Structure:", outputs)
`

    // console.log("code: ", pythonCode)
    pyodideInstance.run(pythonCode)
    console.log("ans------------", pyodideInstance.getResult())

    //     const json = `
    // import json

    // json_str = json.dumps(${pyodideInstance.getResult()})
    // `

    //     pyodideInstance.run(json)
}